<section class="content">
  <div class="card" style="padding:25px">

  <div class="container-fluid">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <!-- <div class="block-header"> -->
      <!-- <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Basic Form</h4>
            </li>
            <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Forms</a>
            </li>
            <li class="breadcrumb-item active">Basic</li>
          </ul>
        </div>
      </div> -->
    <!-- </div> -->
    <!-- <app-maser-page-header></app-maser-page-header> -->
    <br>
    <div class="form-row">
      <div class="col-2" style="border: 1px solid grey; border-radius: 8px; margin-left: 18 px;">
        <input type="text" style="border: none; margin-left: 11px; margin-top: 4px;" class="form-control"
          (keydown.enter)="checkBoothExists()" [(ngModel)]="booth_code" placeholder="Booth Code">
      </div>
      <div class="col-1 text-center" style="font-size: 23px;color: lightslategrey;">or</div>
      <div class="col-2" style="border: 1px solid grey; border-radius: 8px">
        <input type="text" class="form-control" [(ngModel)]="agent_code" (keydown.enter)="checkBoothExists()"
          style="border: none; margin-left: 11px; margin-top: 4px;" placeholder="Agent code">
      </div>
      <div class="col">
        <button mat-raised-button color="primary" (click)="checkBoothExists()" type="button"
          style="margin-top: 7px; margin-left: 18px;">Confirm
        </button>
      </div>
    </div>
    <div *ngIf="business_available">
      <div class="row">
        <div class="col-7">
          <div class="card"
            style="box-shadow: 0px 0px 5px 0px #535252; padding: 15px;font-size: 15px;  margin-top: 18px;">
            <div class="row">
              <div class="col-1"></div>
              <div class="col text-center">
                <h4 style="font-weight: normal;">Agent Details</h4>
              </div>
              <div class="col-2"></div>
            </div>

            <div class="row" style="padding: 10px;">
              <!-- <div class="col-1"></div> -->
              <div class="col">
                <b>Agent Name : </b> {{business_details['agent_name'] }}
              </div>
              <div class="col">
                <b>Agent Code : </b> {{business_details['agent_code'] }}
              </div>
              <div class="col">
                <b>Booth Code :</b> {{business_details['booth_code']}}
              </div>
            </div>
            <div class="row" style="padding: 10px;">
              <!-- <div class="col-1"></div> -->
              <div class="col">
                <b>Booth zone :</b> {{ business_details['booth_zone']}}
              </div>
              <div class="col">
                <b>Booth address :</b> {{business_details['booth_address']}}
              </div>
              <div class="col">
                <b>Agent Mobile :</b> {{ business_details['agent_mobile']}}
              </div>
            </div>
            <div class="row" style="padding: 10px;">
              <!-- <div class="col-1"></div> -->
              <div class="col">
                <b>Booth Type :</b> {{ business_details['booth_type']}}
              </div>
              <div class="col">
                <b>Agent Wallet Balance :</b> {{business_details['agent_wallet_balance']}}
              </div>
              <div class="col"></div>
            </div>
          </div>
          <div class="card"
            style="box-shadow: 0px 0px 5px 0px #535252; padding: 15px;font-size: 15px; margin-top: 18px;">
            <div class="row">
              <div class="col-1"></div>
              <div class="col text-center">
                <h4 style="font-weight: normal;">Payment</h4>
              </div>
              <div class="col-2">
                <button *ngIf="selected_payment_mode == 3" mat-stroked-button color="warn"
                  (click)="clearBankDetails()">clear</button>
              </div>
            </div>
            <div class="row" style="margin-left: 45px;
        margin-top: 16px;">
              <div class="col-1"></div>
              <div class="col-3">
                <mat-form-field appearance="outline" style="padding: 0px;">
                  <mat-label>Select the Payment Mode</mat-label>
                  <mat-select [(ngModel)]="selected_payment_mode" (ngModelChange)="changePayment()">
                    <mat-option *ngFor="let mode of payment_modes" [value]="mode.id">
                      {{mode.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field appearance="outline" style="padding: 0px;margin-left: 75px;">
                  <mat-label>Amount ₹ </mat-label>
                  <input matInput class="inputs" type="number" [(ngModel)]="amount" placeholder="amount" (keydown.enter)="addMoney()"
                    >
                  <!-- <span matPrefix style="top: -20px;">&nbsp;</span> -->
                </mat-form-field>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="div" *ngIf="selected_payment_mode == 3">
              <form [formGroup]="add_money_form">
                <div class="row" style="margin-left: 9px;">
                  <div class="col-3">

                    <mat-form-field appearance="outline" style="padding: 0px;">
                      <mat-label>Bank Name</mat-label>
                      <input matInput class="inputs" type="text" placeholder="Placeholder" formControlName='bank_name'>
                    </mat-form-field>
                  </div>
                  <div class="col-3" style="margin-left: 48px;">
                    <mat-form-field appearance="outline" style="padding: 0px;">
                      <mat-label>Branch Name</mat-label>
                      <input matInput class="inputs" type="text" placeholder="branch name"
                        formControlName='branch_name'>
                    </mat-form-field>
                  </div>
                  <div class="col-3" style="margin-left: 48px;">
                    <mat-form-field appearance="outline" style="padding: 0px;">
                      <mat-label>IFSC Code</mat-label>
                      <input style="text-transform: uppercase;" matInput class="inputs" type="text"
                        placeholder="ifsc code" formControlName='ifsc_code'>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row" style="margin-left: 9px;">
                  <div class="col-3">
                    <mat-form-field appearance="outline" style="padding: 0px;">
                      <mat-label>MICR Code</mat-label>
                      <input matInput class="inputs" type="text" placeholder="Placeholder" formControlName='micr_code'>
                    </mat-form-field>
                  </div>
                  <div class="col-3" style="margin-left: 48px;">
                    <mat-form-field appearance="outline" style="padding: 0px;">
                      <mat-label>Account Holder Name</mat-label>
                      <input matInput class="inputs" type="text" placeholder="account holder name"
                        formControlName='account_holder_name'>
                    </mat-form-field>
                  </div>
                  <div class="col-3" style="margin-left: 48px;">
                    <mat-form-field appearance="outline" style="padding: 0px;">
                      <mat-label>Account Number</mat-label>
                      <input matInput class="inputs" type="number" placeholder="account number"
                        formControlName='account_number'>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row" style="margin-left: 66px; margin-top: 16px;">
                  <div class="col-3" style="margin-left: 48px;">
                    <mat-form-field appearance="outline" style="padding: 0px;">
                      <mat-label>Cheque Number </mat-label>
                      <input matInput class="inputs" type=number placeholder="cheque number"
                        formControlName='cheque_number'>
                    </mat-form-field>
                  </div>
                  <div class="col-3" style="margin-left: 61px;">
                    <mat-form-field appearance="outline" style="padding: 0px;">
                      <mat-label>Date of cheque Issued </mat-label>
                      <input matInput class="inputs" [max]="min_date" type="date" placeholder="date of cheque issued"
                        formControlName='cheque_issue_date'>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row" style="padding-bottom: 26px;">
                  <div class="col text-center">
                    <button (click)="addMoney()" [disabled]="!add_money_form.valid" mat-raised-button
                      color="primary">Add
                      money</button>
                  </div>
                </div>
              </form>
            </div>
            <div class="row" style="padding-bottom: 26px;" *ngIf="selected_payment_mode != 3">
              <div class="col text-center">
                <button (click)="addMoney()" mat-raised-button color="primary">Add money</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="card"
            style="box-shadow: 0px 0px 5px 0px #535252; padding: 15px;font-size: 15px;  margin-top: 18px; height: 3%; overflow: auto;">
            <h4>Agent Transaction</h4>
            <!-- <div class="row">
              <div class="col">
                Old Bal + Amt. Added = New Bal.
              </div>
              <div class="col">
                Date Time
              </div>
              <div class="col">
                User added
              </div>
            </div> -->
            <table style="border: 1px solid lightgray;" class="table-hover">
              <tr style="background: peachpuff;">
                <th style="font-size: 14px;font-weight: 500;">Old Bal. + Amt. Added = New Bal. </th>
                <th style="font-size: 14px;font-weight: 500;">Date Time</th>
                <th style="font-size: 14px;font-weight: 500;">User added</th>
                <th></th>
              </tr>
              <tr *ngFor="let transaction of transaction_history">
                <td style="font-size: 14px;">{{transaction['old_balance']}} + <span>{{transaction['amount']}} </span> =
                  {{transaction['new_balance']}}</td>
                <td style="font-size: 14px;">{{transaction['date'] | date:'d LLL yyyy, h:m aaa'}}</td>
                <td style="font-size: 14px;">{{transaction['data_entered_by']}} </td>
                <td><span class="material-icons">assignment</span></td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </div>
  </div>
  </div>
</section>
